import * as React from 'react';
import history from "../history";
import {ConnectedRouter} from "react-router-redux";
import {Route, Switch} from "react-router-dom";
import {
	ROUTE_SERVICE,
	ROUTE_SERVICE_ALL,
	ROUTE_SERVICE_CREATE, ROUTE_SERVICE_DETAIL, ROUTE_SERVICE_KFZ_ASSIGNMENT,
	ROUTE_SERVICE_NOT_ASSIGNED,
} from "./index";
import ServiceCompleteList from "../components/ServiceCompleteList";
import ServiceNotAssignedList from "../components/ServiceNotAssignedList";
import ServiceListController from "../containers/ServiceListController";
import ServiceCreateController from "../containers/ServiceCreateController";
import ServiceEditController from "../containers/ServiceEditController";
import ServiceKfzAssignmentController from "../containers/ServiceKfzAssignmentController";

export default () => (
	<ConnectedRouter history={history}>
		<Switch>
			<Route exact path={ROUTE_SERVICE_ALL} component={ServiceCompleteList}/>
			<Route exact path={ROUTE_SERVICE_NOT_ASSIGNED} component={ServiceNotAssignedList}/>
			<Route exact path={ROUTE_SERVICE} component={ServiceListController}/>
			<Route exact path={ROUTE_SERVICE_CREATE} component={ServiceCreateController}/>
			<Route exact path={ROUTE_SERVICE_DETAIL} component={ServiceEditController}/>
			<Route exact path={ROUTE_SERVICE_KFZ_ASSIGNMENT} component={ServiceKfzAssignmentController}/>
		</Switch>
	</ConnectedRouter>
);


// WEBPACK FOOTER //
// ./src/routes/ServiceRoutes.js